import {makeStyles} from '@material-ui/core'

export default makeStyles(theme => ({
  title: {
    color: theme.palette.text.primary,
  },
}))
